import type { LegalCopy } from '../types'

export const kn: LegalCopy = {
  title: 'ಕಾನೂನು ನೆರವು',
  subtitle: 'ಸಾಮಾನ್ಯ ಕಾನೂನು ಸಮಸ್ಯೆಗಳು, ಸರಳ ಮಾತುಗಳಲ್ಲಿ. ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ಕೇಳಿ, ಮತ್ತು ಪ್ರತಿ ಉತ್ತರದ ಅಧಿಕೃತ ಸರ್ಕಾರಿ ಮೂಲವನ್ನು ನೋಡಿ.',
  helplinesTitle: 'ಸಹಾಯವಾಣಿಗಳು (ಉಚಿತ ಕರೆ)',
  helplines: {
    emergency: 'ತುರ್ತು: ಪೊಲೀಸ್, ಅಗ್ನಿಶಾಮಕ, ಆಂಬ್ಯುಲೆನ್ಸ್',
    legal_aid: 'ಉಚಿತ ಕಾನೂನು ನೆರವು (NALSA)',
    cyber: 'ಆನ್‌ಲೈನ್ / UPI ವಂಚನೆ',
    women: 'ಮಹಿಳಾ ಸಹಾಯವಾಣಿ',
    consumer: 'ಗ್ರಾಹಕ ಸಹಾಯವಾಣಿ'
  },
  faqTitle: 'ಸಾಮಾನ್ಯ ಪ್ರಶ್ನೆಗಳು',
  searchPlaceholder: 'ಹುಡುಕಿ: FIR, ವಂಚನೆ, RTI, ವಕೀಲ…',
  noMatch: 'ಯಾವ ಪ್ರಶ್ನೆಯೂ ಹೊಂದಲಿಲ್ಲ. ಕೆಳಗೆ ನಿಮ್ಮ ಪ್ರಶ್ನೆ ಕೇಳಿ.',
  sources: 'ಅಧಿಕೃತ ಮೂಲ',
  listen: 'ಕೇಳಿ',
  askTitle: 'ನಿಮ್ಮದೇ ಕಾನೂನು ಪ್ರಶ್ನೆ ಕೇಳಿ',
  askHint: 'ಸಮ್ಝೋ ಅಧಿಕೃತ ಸರ್ಕಾರಿ ವೆಬ್‌ಸೈಟ್‌ಗಳಿಂದ ಮಾತ್ರ ಉತ್ತರ ಕೊಡುತ್ತದೆ, ಮೂಲದ ಲಿಂಕ್ ಜೊತೆಗೆ.',
  starters: ['ನನಗೆ ಉಚಿತ ವಕೀಲರು ಸಿಗುತ್ತಾರೆಯೇ?', 'ಯಾರೋ ನನಗೆ ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ಮೋಸ ಮಾಡಿದರು. ನಾನು ಏನು ಮಾಡಬೇಕು?', 'ಪೊಲೀಸರು ನನ್ನ ದೂರು ಬರೆದುಕೊಳ್ಳುತ್ತಿಲ್ಲ. ನಾನು ಏನು ಮಾಡಬಹುದು?'],
  disclaimer:
    'ಇದು ಅಧಿಕೃತ ಮೂಲಗಳಿಂದ ಪಡೆದ ಸಾಮಾನ್ಯ ಮಾಹಿತಿ, ನಿಮ್ಮ ಪ್ರಕರಣಕ್ಕೆ ಕಾನೂನು ಸಲಹೆ ಅಲ್ಲ. ನಿಮ್ಮ ಪ್ರಕರಣಕ್ಕಾಗಿ ವಕೀಲರ ಜೊತೆ ಮಾತನಾಡಿ — ಕಾನೂನು ಸೇವೆಗಳ ಪ್ರಾಧಿಕಾರದಿಂದ (15100) ನಿಮಗೆ ಉಚಿತ ವಕೀಲರು ಸಿಗಬಹುದು.',
  topics: {
    get_free_aid: {
      q: 'ಉಚಿತ ಕಾನೂನು ನೆರವು ಹೇಗೆ ಪಡೆಯುವುದು?',
      a: 'NALSA ಉಚಿತ ಸಹಾಯವಾಣಿ 15100 ಗೆ ಕರೆ ಮಾಡಿ. ಅಥವಾ ನಿಮ್ಮ ಜಿಲ್ಲಾ ನ್ಯಾಯಾಲಯದಲ್ಲಿರುವ ಕಾನೂನು ಸೇವೆಗಳ ಪ್ರಾಧಿಕಾರದ ಕಚೇರಿಗೆ, ಅಥವಾ ನಿಮ್ಮ ತಾಲ್ಲೂಕು ನ್ಯಾಯಾಲಯದಲ್ಲಿರುವ ಕಾನೂನು ಸೇವೆಗಳ ಸಮಿತಿಗೆ ಹೋಗಿ. ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ, ಅಂಚೆ ಮೂಲಕ ಅಥವಾ ಇ-ಮೇಲ್ ಮೂಲಕವೂ ಅರ್ಜಿ ಹಾಕಬಹುದು. ಅರ್ಜಿ ನಮೂನೆ ಉಚಿತ. ವಕೀಲರ ಶುಲ್ಕ ಮತ್ತು ನ್ಯಾಯಾಲಯದ ಖರ್ಚನ್ನು ನಿಮ್ಮ ಪರವಾಗಿ ಪಾವತಿಸಲಾಗುತ್ತದೆ.'
    },
    who_free_aid: {
      q: 'ಉಚಿತ ವಕೀಲರು ಯಾರಿಗೆ ಸಿಗುತ್ತಾರೆ?',
      a: 'ಕಾನೂನು (ಕಾನೂನು ಸೇವೆಗಳ ಪ್ರಾಧಿಕಾರಗಳ ಕಾಯ್ದೆ, ಸೆಕ್ಷನ್ 12) ಇವರಿಗೆ ಉಚಿತ ಕಾನೂನು ನೆರವು ಕೊಡುತ್ತದೆ: ಮಹಿಳೆಯರು ಮತ್ತು ಮಕ್ಕಳು, SC/ST ಸಮುದಾಯದವರು, ವಿಕಲಚೇತನರು, ಕೈಗಾರಿಕಾ ಕಾರ್ಮಿಕರು, ಮಾನವ ಕಳ್ಳಸಾಗಣೆ ಅಥವಾ ಬಲವಂತದ ದುಡಿಮೆಗೆ (ಜೀತ) ಒಳಗಾದವರು, ವಿಪತ್ತು, ಜಾತಿ ದೌರ್ಜನ್ಯ ಅಥವಾ ಜನಾಂಗೀಯ ಹಿಂಸೆಗೆ ಒಳಗಾದವರು, ಬಂಧನದಲ್ಲಿ (ಕಸ್ಟಡಿ) ಇರುವವರು, ಮತ್ತು ತಮ್ಮ ರಾಜ್ಯ ನಿಗದಿಪಡಿಸಿದ ಮಿತಿಗಿಂತ ಕಡಿಮೆ ವಾರ್ಷಿಕ ಆದಾಯ ಇರುವವರು. ಈ ಆದಾಯ ಮಿತಿ ಒಂದೊಂದು ರಾಜ್ಯದಲ್ಲಿ ಒಂದೊಂದು ರೀತಿ ಇರುತ್ತದೆ.'
    },
    fir: {
      q: 'ಪೊಲೀಸರು ನನ್ನ FIR ದಾಖಲಿಸುತ್ತಿಲ್ಲ. ನಾನು ಏನು ಮಾಡಬಹುದು?',
      a: 'ಗಂಭೀರ (ಸಂಜ್ಞೇಯ) ಅಪರಾಧ ಆಗಿದ್ದರೆ, ಅದು ಬೇರೆ ಕಡೆ ನಡೆದಿದ್ದರೂ, ಯಾವುದೇ ಪೊಲೀಸ್ ಠಾಣೆಯಲ್ಲಿ ದೂರು ಕೊಡಬಹುದು — ಇದನ್ನು ಝೀರೋ FIR ಎನ್ನುತ್ತಾರೆ. ಪೊಲೀಸರು FIR ಪ್ರತಿಯನ್ನು ನಿಮಗೆ ಉಚಿತವಾಗಿ ಕೊಡಬೇಕು. ಅವರು ನಿರಾಕರಿಸಿದರೆ, ನಿಮ್ಮ ದೂರನ್ನು ಬರವಣಿಗೆಯಲ್ಲಿ ಅಂಚೆ ಮೂಲಕ ಪೊಲೀಸ್ ವರಿಷ್ಠಾಧಿಕಾರಿಗೆ (SP) ಕಳುಹಿಸಿ. SP ಕೂಡ ಏನೂ ಮಾಡದಿದ್ದರೆ, ಪ್ರಮಾಣ ಪತ್ರದ (ಅಫಿಡವಿಟ್) ಜೊತೆಗೆ ಮ್ಯಾಜಿಸ್ಟ್ರೇಟರಿಗೆ ಅರ್ಜಿ ಹಾಕಬಹುದು.'
    },
    cyber_fraud: {
      q: 'ಆನ್‌ಲೈನ್ ಅಥವಾ UPI ವಂಚನೆಯಲ್ಲಿ ನನ್ನ ಹಣ ಹೋಯಿತು. ನಾನು ಏನು ಮಾಡಬೇಕು?',
      a: 'ತಕ್ಷಣ 1930 ಗೆ ಕರೆ ಮಾಡಿ. ಇದು ಉಚಿತ ರಾಷ್ಟ್ರೀಯ ಸೈಬರ್ ಅಪರಾಧ ಸಹಾಯವಾಣಿ — ಹಗಲು ರಾತ್ರಿ ಕೆಲಸ ಮಾಡುತ್ತದೆ. ಬೇಗ ದೂರು ಕೊಟ್ಟರೆ, ಹಣ ಬೇರೆ ಕಡೆಗೆ ಸಾಗಿಸುವುದನ್ನು ತಡೆಯಲು ಸಹಾಯವಾಗುತ್ತದೆ. cybercrime.gov.in ನಲ್ಲಿ “Financial Fraud” ಅಡಿಯಲ್ಲೂ ದೂರು ದಾಖಲಿಸಿ.'
    },
    women: {
      q: 'ಒಬ್ಬ ಮಹಿಳೆ ಹಿಂಸೆ ಅಥವಾ ಕಿರುಕುಳ ಎದುರಿಸುತ್ತಿದ್ದಾರೆ. ಅವರಿಗೆ ಸಹಾಯ ಎಲ್ಲಿ ಸಿಗುತ್ತದೆ?',
      a: 'ತುರ್ತು ಸಂದರ್ಭದಲ್ಲಿ ಪೊಲೀಸ್, ಅಗ್ನಿಶಾಮಕ ಅಥವಾ ಆಂಬ್ಯುಲೆನ್ಸ್‌ಗಾಗಿ 112 ಗೆ ಕರೆ ಮಾಡಿ. ಉಚಿತ ಮಹಿಳಾ ಸಹಾಯವಾಣಿ 181 ಗೆ ಹಗಲು ರಾತ್ರಿ ಯಾವಾಗ ಬೇಕಾದರೂ ಕರೆ ಮಾಡಿ. ನಿಮ್ಮ ಹೆಸರು ಹೇಳದೆಯೂ ಮಾತನಾಡಬಹುದು. ಇದು ನಿಮ್ಮನ್ನು ಪೊಲೀಸ್, ಒನ್ ಸ್ಟಾಪ್ ಸೆಂಟರ್, ಆಸ್ಪತ್ರೆ ಅಥವಾ ಕಾನೂನು ನೆರವಿನ ಜೊತೆ ಸಂಪರ್ಕಿಸುತ್ತದೆ. ರಾಷ್ಟ್ರೀಯ ಮಹಿಳಾ ಆಯೋಗಕ್ಕೂ 14490 ಎಂಬ ಸಹಾಯವಾಣಿ ಇದೆ, ಅದು ಆನ್‌ಲೈನ್‌ನಲ್ಲೂ ದೂರುಗಳನ್ನು ಸ್ವೀಕರಿಸುತ್ತದೆ.'
    },
    consumer: {
      q: 'ಒಂದು ಅಂಗಡಿ ಅಥವಾ ಕಂಪನಿ ನನಗೆ ಮೋಸ ಮಾಡಿದೆ. ಎಲ್ಲಿ ದೂರು ಕೊಡಬೇಕು?',
      a: 'ರಾಷ್ಟ್ರೀಯ ಗ್ರಾಹಕ ಸಹಾಯವಾಣಿ 1915 ಗೆ ಕರೆ ಮಾಡಿ (ಉಚಿತ, ಬೆಳಿಗ್ಗೆ 8 ರಿಂದ ರಾತ್ರಿ 8 ರವರೆಗೆ), 8800001915 ಗೆ WhatsApp ಸಂದೇಶ ಕಳುಹಿಸಿ, ಅಥವಾ consumerhelpline.gov.in ನಲ್ಲಿ ದೂರು ಕೊಡಿ. ಗ್ರಾಹಕ ಆಯೋಗದಲ್ಲಿ ಪ್ರಕರಣ ದಾಖಲಿಸಲು, e-Daakhil ನಲ್ಲಿ ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ಮಾಡಬಹುದು.'
    },
    summons: {
      q: 'ನನಗೆ ನ್ಯಾಯಾಲಯದ ಸಮನ್ಸ್ ಬಂದಿದೆ. ನಾನು ಏನು ಮಾಡಬೇಕು?',
      a: 'ಒಂದು ನಿರ್ದಿಷ್ಟ ದಿನಾಂಕದಂದು ನ್ಯಾಯಾಲಯಕ್ಕೆ ಬರಬೇಕು ಎಂದು ಸಮನ್ಸ್ ಹೇಳುತ್ತದೆ. ನೀವು ಅರ್ಹರಾಗಿದ್ದರೆ, ಪ್ರಕರಣದ ಯಾವುದೇ ಹಂತದಲ್ಲಿ ಉಚಿತ ವಕೀಲರನ್ನು ಪಡೆಯಬಹುದು: 15100 ಗೆ ಕರೆ ಮಾಡಿ ಅಥವಾ ನಿಮ್ಮ ಜಿಲ್ಲಾ ನ್ಯಾಯಾಲಯದಲ್ಲಿರುವ ಕಾನೂನು ಸೇವೆಗಳ ಕಚೇರಿಗೆ ಹೋಗಿ. ನಿಮ್ಮ ಪ್ರಕರಣ ಮತ್ತು ಅದರ ಮುಂದಿನ ದಿನಾಂಕವನ್ನು eCourts ವೆಬ್‌ಸೈಟ್ ಅಥವಾ ಆ್ಯಪ್‌ನಲ್ಲಿ ನೋಡಬಹುದು.'
    },
    case_status: {
      q: 'ನನ್ನ ನ್ಯಾಯಾಲಯ ಪ್ರಕರಣದ ಸ್ಥಿತಿ ಹೇಗೆ ನೋಡುವುದು?',
      a: 'services.ecourts.gov.in ಗೆ ಹೋಗಿ, ಅಥವಾ eCourts Services ಆ್ಯಪ್ ಬಳಸಿ. ನಿಮ್ಮ 16 ಅಂಕಿಯ CNR ಸಂಖ್ಯೆ ಅಥವಾ ಪ್ರಕರಣದ ಇತರ ವಿವರಗಳಿಂದ ಹುಡುಕಿ. SMS ಕೂಡ ಕಳುಹಿಸಬಹುದು: ECOURTS, ಒಂದು ಸ್ಪೇಸ್, ನಂತರ ನಿಮ್ಮ CNR ಸಂಖ್ಯೆ ಬರೆದು 9766899899 ಗೆ ಕಳುಹಿಸಿ.'
    },
    lok_adalat: {
      q: 'ಲೋಕ ಅದಾಲತ್ ಎಂದರೇನು?',
      a: 'ಲೋಕ ಅದಾಲತ್ ಎರಡೂ ಕಡೆಯವರ ಒಪ್ಪಿಗೆಯಿಂದ ಪ್ರಕರಣಗಳನ್ನು ಇತ್ಯರ್ಥ ಮಾಡುತ್ತದೆ. ಇದಕ್ಕೆ ನ್ಯಾಯಾಲಯ ಶುಲ್ಕ ಇಲ್ಲ. ಈಗಾಗಲೇ ನ್ಯಾಯಾಲಯದಲ್ಲಿರುವ ಪ್ರಕರಣ ಇಲ್ಲಿ ಇತ್ಯರ್ಥವಾದರೆ, ನೀವು ಕಟ್ಟಿದ ನ್ಯಾಯಾಲಯ ಶುಲ್ಕವನ್ನು ಹಿಂದಿರುಗಿಸಲಾಗುತ್ತದೆ. ಇದರ ತೀರ್ಮಾನ ನ್ಯಾಯಾಲಯದ ಡಿಕ್ರಿಯಂತೆಯೇ ಅಂತಿಮ, ಕಡ್ಡಾಯವಾಗಿ ಪಾಲಿಸಬೇಕು. ಇದರ ವಿರುದ್ಧ ಮೇಲ್ಮನವಿ ಇಲ್ಲ.'
    },
    rti: {
      q: 'RTI ಹೇಗೆ ಸಲ್ಲಿಸುವುದು?',
      a: 'ಕೇಂದ್ರ ಸರ್ಕಾರದ ಕಚೇರಿಗಳಿಗೆ rtionline.gov.in ನಲ್ಲಿ ಆನ್‌ಲೈನ್ ಅರ್ಜಿ ಹಾಕಿ. ಶುಲ್ಕ ₹10. ನೀವು ಬಡತನ ರೇಖೆಗಿಂತ ಕೆಳಗಿದ್ದರೆ ಶುಲ್ಕ ಇಲ್ಲ (ನಿಮ್ಮ BPL ಪ್ರಮಾಣಪತ್ರ ಲಗತ್ತಿಸಿ). ಅಧಿಕಾರಿ 30 ದಿನಗಳ ಒಳಗೆ ಉತ್ತರ ಕೊಡಬೇಕು. ಯಾರದೇ ಜೀವ ಅಥವಾ ಸ್ವಾತಂತ್ರ್ಯದ ವಿಷಯ ಆಗಿದ್ದರೆ 48 ಗಂಟೆಗಳ ಒಳಗೆ ಕೊಡಬೇಕು. 30 ದಿನಗಳಲ್ಲಿ ಉತ್ತರ ಬರದಿದ್ದರೆ, ಮುಂದಿನ 30 ದಿನಗಳ ಒಳಗೆ ಉಚಿತವಾಗಿ ಮೊದಲ ಮೇಲ್ಮನವಿ ಸಲ್ಲಿಸಬಹುದು.'
    },
    grievance: {
      q: 'ಸರ್ಕಾರಿ ಕಚೇರಿ ನನ್ನ ಕೆಲಸ ಮಾಡುತ್ತಿಲ್ಲ. ಎಲ್ಲಿ ದೂರು ಕೊಡಬೇಕು?',
      a: 'pgportal.gov.in ನಲ್ಲಿರುವ CPGRAMS ನಲ್ಲಿ ದೂರು ದಾಖಲಿಸಿ. ಇದು ಹಗಲು ರಾತ್ರಿ ತೆರೆದಿರುತ್ತದೆ (ಅದರ ಆ್ಯಪ್‌ನಲ್ಲೂ, UMANG ನಲ್ಲೂ ಇದೆ). 21 ದಿನಗಳ ಒಳಗೆ ಬಗೆಹರಿಸುವುದು ಗುರಿ. RTI ವಿಷಯಗಳು, ನ್ಯಾಯಾಲಯದ ಪ್ರಕರಣಗಳು, ಧಾರ್ಮಿಕ ವಿಷಯಗಳು ಅಥವಾ ಸರ್ಕಾರಿ ನೌಕರರ ಸೇವಾ ವಿಷಯಗಳನ್ನು ಇದರಲ್ಲಿ ತೆಗೆದುಕೊಳ್ಳುವುದಿಲ್ಲ.'
    }
  }
}
